import cx from "../../../lib/cx";
import styles from "./inputText.css";

/**
 * The text input is a steps element that allows the user to type in single line
 * text. It comes with a label and indicates if it is a required steps field.
 * An error message is displayed, when an error is given.
 *
 * @param {object} params - The parameters object to configure the input field.
 * @param {string} [params.type="text"] - The type of the input field (e.g., text, password, email).
 * @param {string} params.name - The name of the input field, used for forms and identification.
 * @param {string} params.label - The label text displayed for the input field.
 * @param {string} params.value - The current value of the input field.
 * @param {boolean} [params.required=false] - Whether the input field is mandatory.
 * @param {Function} params.onChange - The callback function triggered when the input value changes.
 * @param {string|null} params.error - The error message displayed below the input field.
 * @param {number} [params.minLength] - The minimum number of characters allowed in the input field.
 * @param {number} [params.maxLength] - The maximum number of characters allowed in the input field.
 * @param {boolean} [params.width100=false] - Whether the input field width should span 100% of its container.
 * @param {Function} [params.onBlur] - The callback function triggered when the input field loses focus.
 * @param {string} [params.theme="light"] - The visual theme applied to the input field. Can be "light" or "dark".
 *
 * @return {JSX.Element} The JSX representation of the input field component.
 */
function InputText({
  type = "text",
  name,
  label,
  value,
  required = false,
  onChange,
  error,
  minLength,
  maxLength,
  width100 = false,
  onBlur,
  theme = "light",
}) {
  return (
    <div
      className={cx(
        styles.control[error ? "error" : "default"],
        width100 && styles.wide,
      )}
    >
      <input
        type={type}
        className={styles.inputText[theme]}
        placeholder=" "
        name={name}
        id={name}
        required={required}
        value={value}
        onChange={onChange}
        minLength={minLength}
        maxLength={maxLength}
        onBlur={onBlur}
      />

      {label && (
        <label htmlFor={name} className={styles.label[theme]}>
          {label}
          {required && "*"}
        </label>
      )}

      {error && <p className={styles.error}>{error}</p>}
    </div>
  );
}

export default InputText;
